import { Modal, DatePickerField } from 'components';
import Button from 'components/Button';
import ButtonSubmit from 'components/Forms/ButtonSubmit';
import SelectField from 'components/Forms/SelectField';
import { FormikProvider, useFormik } from 'formik';
import { Form } from 'formik-antd';
import { yup } from 'libs';
import { FC, useState } from 'react';
import { arrowLeft } from 'assets';

import SectionStyled, { HeaderStyle } from './styles';

interface Props {}

const ModalAddHistoryWork: FC<Props> = () => {
  const [visible, setVisible] = useState<boolean>(false);
  const formik = useFormik({
    initialValues,
    validationSchema,
    async onSubmit(values) {
      console.log(values);
      setVisible(false);
    },
  });

  return (
    <>
      <button onClick={() => setVisible(true)}>Modal Add History Work</button>
      <Modal title={<Header />} visible={visible} footer={false} width={560}>
        <SectionStyled>
          <FormikProvider value={formik}>
            <Form layout="vertical" className="form">
              <div className="group-input">
                <div className="box-select box-top">
                  <Form.Item className="input-onsite" label="現場" colon={false} name="onSite">
                    <SelectField data={onSite} name="onSite" className="select-field" />
                  </Form.Item>
                </div>
                <div className="box-select">
                  <Form.Item
                    className="input-onsite"
                    label="出力期間"
                    colon={false}
                    name="startDate"
                  >
                    <DatePickerField
                      name="startDate"
                      className="select-date"
                      placeholder="開始日を選択"
                    />
                  </Form.Item>
                  <div className="center-text">〜</div>
                  <Form.Item className="input-checkbox" label={<span />} name="endDate">
                    <DatePickerField
                      name="endDate"
                      className="select-date"
                      placeholder="終了日を選択"
                    />
                  </Form.Item>
                </div>
              </div>
              <div className="ant-modal-footer">
                <Button className="button-secondary" onClick={() => setVisible(false)}>
                  キャンセル
                </Button>
                <ButtonSubmit>追加</ButtonSubmit>
              </div>
            </Form>
          </FormikProvider>
        </SectionStyled>
      </Modal>
    </>
  );
};

export default ModalAddHistoryWork;

const onSite = [
  { label: '東京内田中様集合住宅新築工事', value: '東京内田中様集合住宅新築工事' },
  { label: 'name 1', value: 1 },
  { label: 'name 2', value: 2 },
  { label: 'name 3', value: 3 },
];

const initialValues = {
  onSite: '東京内田中様集合住宅新築工事',
  startDate: '',
  endDate: '',
};

const validationSchema = yup.object().shape({
  onSite: yup.string().required(),
  startDate: yup.date().nullable().required(),
  endDate: yup.date().nullable().required(),
});

const Header: FC = () => {
  return (
    <HeaderStyle>
      <img src={arrowLeft} alt="" />
      <div>作業予定の追加</div>
    </HeaderStyle>
  );
};
